import { addSelectedFiltersToQuery } from 'src/utils/utils';
import { request } from '../api';

export type DeviceListCounts = { alarms: { total: number; byCriticality: Record<string, number> }; workOrders: number };

export interface DeviceListCircuit extends DeviceListCounts {
  id: string;
  tag: string;
  description: string | null;
  model: string | null;
  unit: string | null;
  offline: boolean;
  forcedOn: boolean;
  loto: boolean;
}

export interface DeviceListItem extends DeviceListCounts {
  id: string;
  kind: 'controller' | 'standaloneCircuit';
  tag: string;
  description: string | null;
  model: string | null;
  unit: string | null;
  panel: { id: string; tag: string } | null;
  offline: boolean;
  forcedOn: boolean;
  loto: boolean;
  matched: boolean;
  circuitCount: number;
  rollup: DeviceListCounts;
  circuits: DeviceListCircuit[];
}

export interface DeviceListResponse {
  data: DeviceListItem[];
  /** Top-level rows; pages are counted in these. (ie controllers) */
  total: number;
  /** Rows plus their matching circuits, across all pages. */
  deviceCount: number;
  offset: number;
  nextOffset: number;
  hasMore: boolean;
}

export interface DeviceListScope {
  panelId?: string;
  controllerId?: string;
}

export interface DeviceListQuery {
  selectedFilters: any;
  sort: string;
  scope?: DeviceListScope;
}

const PAGE_SIZE = 25;

export const getDeviceList = (action, { selectedFilters, sort, scope }: DeviceListQuery, offset: number): Promise<DeviceListResponse> => {
  const query: any = addSelectedFiltersToQuery(selectedFilters, { sort, offset, limit: PAGE_SIZE });
  if (scope?.panelId) query.panelId = scope.panelId;
  if (scope?.controllerId) query.controllerId = scope.controllerId;

  return request(action, {
    payload: {
      url: '/eht-controllers/list',
      query,
      options: { method: 'GET' }
    },
    normalize: (data) => data.toJS()
  });
};
